








































import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import AvailabilityRestrictionSummary from '@/models/AvailabilityRestrictions/AvailabilityRestrictionSummary';

@Component({
  name: 'AvailabilityRestrictionSummary',
})
export default class extends GiganautVue {

	@Prop({required: true})
	weeklySummaries: AvailabilityRestrictionSummary[];

	get summaries() {
		return JSON.parse(JSON.stringify(this.weeklySummaries));
	}

	get breached() {
		if (this.summaries.length === 0) {
			return false
		}
		let breached = false;
		for (let i = 0; i < this.summaries.length; i++) {
			if (this.summaries[i].isRestrictionBreached) {
				breached = true;
				break;
			}
		}
		return breached;
	}
}
